import _ from 'lodash';

export const getKetrometaryDiopterData = (arr, type) => {
  const values = arr
    .map(item => item.value)
    .filter(num => !isNaN(num));
  let groupedArrays = [], ranges = [];
  if (type === 'mm') {
    // add highest and lowest value for range in mm
    ranges = [{ min: 14.67, max: 7.29 }, { min: 7.27, max: 3.91 }];
  } else {
    ranges = [{ min: 23, max: 46.25 }, { min: 46.37, max: 76 }];
  }
  groupedArrays = ranges.map(range => {
    const min = Math.min(range.min, range.max);
    const max = Math.max(range.min, range.max);
    return values.filter(val => val >= min && val <= max);
  });
  let arr1 = _.chunk(['', ...groupedArrays[0]], 35);
  let arr2 = _.chunk(groupedArrays[1], 35);
  arr1 = _.chunk(arr1, 2);
  arr2 = _.chunk(arr2, 2);
  return [arr1, arr2];
};

export const getAxisData = (arr) => [arr.slice(0, 60), arr.slice(60, 120), arr.slice(120, 180)];

export const getPositiveNegativeData = (arr, additionalValues) => {
  const data = arr.flat();

  let positiveArr = [];
  let negativeArr = [];
  let neutralArr = [];

  for (const item of data) {
    const key = item.key?.toString();
    if (!key) continue;
    if (key.includes('+')) {
      positiveArr.push(item);
    } else if (key.includes('-')) {
      negativeArr.push(item);
    } else {
      neutralArr.push(item);
    }
  }
  if (additionalValues && additionalValues.length) {
    // Add additional values into neutral
    neutralArr.push(...additionalValues.map(item => ({ key: item })));
  }
  positiveArr = groupData(positiveArr);
  negativeArr = groupData(negativeArr);
  neutralArr = [neutralArr];
  const finalArr = [positiveArr, neutralArr, negativeArr].filter(arr => arr.length);
  return finalArr;
};

export const groupData = (arr) => {
  const grouped = arr.reduce((acc, item) => {
    const val = item.key?.trim();
    const num = parseFloat(val);
    if (!isNaN(num)) {
      const groupKey = (num >= 0 ? Math.floor(num) : Math.ceil(num)).toString();
      if (!acc[groupKey]) acc[groupKey] = [];
      acc[groupKey].push(item);
    }
    return acc;
  }, {});
  return Object.values(grouped);
}
